import { render, staticRenderFns } from "./ArticleContentRender.vue?vue&type=template&id=115a8d81"
import script from "./ArticleContentRender.vue?vue&type=script&lang=js"
export * from "./ArticleContentRender.vue?vue&type=script&lang=js"
import "./ArticleContentRender.vue?vue&type=style&index=0&id=115a8d81&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports